import { injectAtomInstance } from './injectAtomInstance.js';
export const injectAtomValue = (atom, params) => {
    const instance = injectAtomInstance(atom, params, {
        operation: 'injectAtomValue',
        subscribe: true,
    });
    return instance.store.getState();
};
